import { ClientInfo, RedirectAttrs } from '../models/commonModels';
import fetch from './fetch';

// is this missing headers?
export const getClientInfo = (redirectAttrs: RedirectAttrs): Promise<ClientInfo> =>
    fetch<ClientInfo>(
        `/clients/${redirectAttrs.client_id}`,
        {
            method: 'GET',
        },
        redirectAttrs
    );
